import { ServiceSchema } from "@redotech/redo-fulfillment-carrier-common/carrier-service-catalog";
import { CarrierSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const aims360ShipViaMapping = z.object({
  carrier: CarrierSchema,
  service: ServiceSchema,
  shipViaId: z.string().min(1),
  shipViaCode: z.string(),
});

export const aims360Settings = defineIntegrationSettings({
  fields: {
    baseUrl: z.string().trim().min(1, "Base URL is required"),
    returnsEnabled: z.boolean(),
    aims360DefaultReturnReasonID: z.string().trim().nullable().optional(),
    omsEnabled: z.boolean(),
    warehouseCodes: z.array(z.string().trim().min(1)),
    servicesToShipViaMappings: z.array(aims360ShipViaMapping),
  },
  secrets: {
    bearerToken: z.string().trim().min(1, "Bearer token is required"),
  },
  connectOnly: {},
  computed: {},
});
